import React, { useEffect } from "react";
import Layout from "../../../components/mobile/Layout/layoutmobile";

import "./css/personalized.css";
import "./css/manager.css";
import { useLocation } from "@reach/router";
import { pushtracking } from "../../../service/trackingService";

const Quydinhchinhsach =()=> {
    const location = useLocation();
    useEffect(() => {
        try{
            pushtracking(window.localStorage.getItem('sessionId')??null,
            window.localStorage.getItem('_id')??null,
            window.localStorage.getItem('phone')??null ,
            location.pathname, "Quy định, chính sách", 0,0,'index','inWeb',[],'Website Mobile').then((response)=>{
                // console.log('send tracking');
            });
        }catch(e){console.log(e)}
    },[])
    const handleClick=(uri)=>{
        window.location.href = uri;
    }
  return (
    <Layout>
        <div className="fixed">
            <div className="header1 filter">
                <div className="row mgx-0 pdy-10 pdx-0">
                    <div className="col-2 in-f">
                        <a onClick={()=>handleClick('/account/manager.html')}>
                            <img src="/../images/voucher/ic_back.svg" alt="icon"/>
                        </a>
                    </div>
                    <div className="col-8 text-center">
                        <strong className="text_header  color_black">QUY ĐỊNH, CHÍNH SÁCH </strong>
                    </div>
                    <div className="col-2"></div>
                </div>
            </div>  
        </div>
        <div style={{ height: 40 }}></div>
        <div className="regulation-bixu bg-white mgt-10">
            <div className="content pdx-0">
                <div className="row mgx-0">
                    <div className="col-12 mgt-10 pdx-0" onClick={()=>handleClick('/quy-dinh-chung.html')}>
                        <div className="guide-tab jus-content pdy-10" >
                            <div className="flex-nowrap color_gray">
                                <span className="text_12 font_700 text_line_none">QUY ĐỊNH CHUNG</span>
                            </div>
                            <img src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/down.png" alt="icon"/>
                        </div>
                    </div>
                    <div className="col-12 mgt-10 pdx-0" onClick={()=>handleClick('/su-dung-thong-tin.html')}>
                        <div className="guide-tab jus-content pdy-10">
                            <div className="flex-nowrap color_gray">
                                <span className="text_12  font_700 text_line_none">CHÍNH SÁCH BẢO MẬT</span>
                            </div>
                            <img src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/down.png" alt="icon"/>
                        </div>
                    </div>
                    <div className="col-12 mgt-10 pdx-0" onClick={()=>handleClick('/chinh-sach-bao-hanh.html')}>
                        <div className="guide-tab jus-content pdy-10">
                            <div className="flex-nowrap color_gray">
                                <span className="text_12  font_700 text_line_none">CHÍNH SÁCH BẢO HÀNH</span>
                            </div>
                            <img src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/down.png" alt="icon"/>
                        </div>
                    </div>
                    <div className="col-12 mgt-10 pdx-0" onClick={()=>handleClick('/dem-xu-ngay-doi-qua-lien-tay.html')}>
                        <div className="guide-tab jus-content pdy-10">
                            <div className="flex-nowrap color_gray">   
                                <span className="text_12  font_700 text_line_none">QUY ĐỊNH TÍCH & TIÊU BIXU</span>
                            </div>
                            <img src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/down.png" alt="icon"/>
                        </div>
                    </div>
                </div>    
            </div>
        </div>
    </Layout>
  )
}

export default Quydinhchinhsach;